import { render, staticRenderFns } from "./ProformDataTableMobile.vue?vue&type=template&id=4bedb36e&scoped=true"
import script from "./ProformDataTableMobile.vue?vue&type=script&lang=js"
export * from "./ProformDataTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bedb36e",
  null
  
)

export default component.exports